import { colors, makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  buttonBox: {
    justifyContent: 'end',
  },
  optionTitle: {
    fontWeight: 'bolder',
  },

  optionBox: {
    marginBlock: theme.spacing(1),
  },

  dialogContent: {
    overflow: 'hidden',
  },
  recommended: {
    marginLeft: '1em',
    borderRadius: '4px',
    backgroundColor: colors.blue[50],
    color: colors.blue[800],
    fontWeight: 700,
    height: '21px',
  },
}))

export default styles
